import {createAction} from '@reduxjs/toolkit'
import type {PageDates} from '@wix/wix-events-commons-statics'

export const updateDates = createAction<PageDates>('UPDATE_DATES')
